.container {
    composes: container from '../home.module.css';
}

.title {
    margin-top: 12px;
}

.scroll-container {
    overflow: auto;
    height: calc(100% - 67px); /* full height minus the footer */
}

.footer {
    /* Required so it renders above add-on slider popover */
    z-index: 10;
    padding: 8px 16px;
    border-top: 1px solid var(--off-white-dk);
    background-color: var(--white);
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    width: calc(100% - 200px); /* full width minus the sidebar */
    height: 67px;
}

.main-sidebar-collapsed {
    width: calc(100% - 64px); /* full width minus the collapsed sidebar */
}

.ai-agent-sidebar-open {
    width: calc(100% - 600px);
}

.main-closed-agent-open {
    width: calc(100% - 464px);
}

@media screen and (max-width: 690px) {
    .info {
        display: none;
    }
}

@media screen and (max-width: 1220px) {
    .info-agent-open {
        display: none;
    }
}

.breadcrumbs-container {
    min-width: 200px;
    max-width: 100%;
    width: 65%;
    overflow-x: auto;
    white-space: nowrap;
    flex-shrink: 1;
    flex: 1;
}

.copyable-link-container {
    width: 330px;
}
